import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../hybrid/wrappers';
import { t } from '../../../../common/components/T';
import css from './UserStats.module.scss';
import classNames from 'classnames';

const UserStats = ({ data, trans }) => {
    const statsUser = [
        {
            title: t('user_modal_NewUser', 'Новых', 'widget', trans, 'userModal'),
            background: 'var(-greenTransparentColor)',
            color: 'var(--greenColor)',
            svg: 'user-plus',
            value: data.new_partners_number || 0
        },
        {
            title: t('user_modal_ActiveUser', 'Активных', 'widget', trans, 'userModal'),
            background: 'var(--blueColorTransparent)',
            color: 'var(--blueColor)',
            svg: 'user-check',
            value: data.active_partners_number || 0
        },
        {
            title: t('user_modal_SelfInvited', 'Лично пригл.', 'widget', trans, 'userModal'),
            background: 'var(--orangeDeepTransparentColorLight)',
            color: 'var(--orangeDeepColorLight)',
            svg: 'user-arrow',
            value: data.children_number || data.children_count || 0
        },
        {
            title: t('user_modal_All', 'Всего', 'widget', trans, 'userModal'),
            background: 'var(--purpleDeepTransparentColor)',
            color: 'var(--purpleDeepColor)',
            svg: 'users',
            value: data.partners_number || data.descendants_count || 0
        },
        ...(data.binary_partners?.left
            ? [
                  {
                      title: t('user_modal_LeftBranch', 'Левая ветка', 'widget', trans, 'userModal'),
                      background: 'var(--greyExtraDarkColorTransparent)',
                      color: 'var(--greyExtraDarkColor)',
                      svg: 'structure-1-2',
                      value: data.binary_partners?.left || 0
                  }
              ]
            : []),
        ...(data.binary_partners?.right
            ? [
                  {
                      title: t('user_modal_RightBranch', 'Правая ветка', 'widget', trans, 'userModal'),
                      background: 'var(--greyExtraDarkColorTransparent)',
                      color: 'var(--greyExtraDarkColor)',
                      svg: 'structure-2-2',
                      value: data.binary_partners?.right || 0
                  }
              ]
            : [])
    ];
    return (
        <div className={css.userModalChildrenBlock}>
            {statsUser &&
                statsUser.map((stats, ind) => (
                    <div key={`statsUser_${ind}`} className={css.userModalChildrenItem}>
                        <div
                            className={classNames(css.userModalChildrenNew, css.userModalChildrenItemBlock)}
                            style={{ background: stats.background }}
                        >
                            <div className={css.userModalChildrenIcon}>
                                {svgSprite(stats.svg, {
                                    width: '28',
                                    height: '28',
                                    fill: stats.color
                                })}
                            </div>
                            <div>
                                <p className={css.userModalChildrenTitle}>{stats.value === 0 ? '0' : stats.value}</p>
                                <p className={css.userModalChildrenText}>{stats.title}</p>
                            </div>
                        </div>
                    </div>
                ))}
        </div>
    );
};
UserStats.propTypes = {
    styles: PropTypes.object,
    newUser: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeUser: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    allUser: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default UserStats;
